import { Box, LinkButtonTo, Stack } from "@skailer-com/uikit";
import { twMerge } from "tailwind-merge";

const theme = {
  variants: {
    primary: "bg-brand-dark",
    secondary: "bg-brand-dark/20",
  },
};

export interface ReportingBarTableCellItem {
  value: number;
  title?: string;
  bgColor?: string;
  bgHoverColor?: string;
}

export interface ReportingBarTableCell {
  value: number;
  title?: string;
  entity_ids?: number[];
  bgColor?: string;
  bgHoverColor?: string;
  tooltipContent?: string | React.ReactNode | undefined;
  subCells?: ReportingBarTableCellItem[];
}

export interface ReportingBarTableCellProps {
  variant: keyof typeof theme.variants;
  width: number;
  title: string;
  onClick?: () => void;
  bgColor?: string;
  bgHoverColor?: string;
  isLast?: boolean;
  hideTitle?: boolean;
  useGroupHover?: boolean;
}

export const ReportingBarTableCell = ({
  onClick,
  variant = "primary",
  width,
  title,
  bgColor,
  bgHoverColor,
  isLast = true,
  hideTitle = false,
  useGroupHover = false,
}: ReportingBarTableCellProps) => {
  const hoverClass = useGroupHover
    ? "group-hover:bg-[var(--hover-bg)]"
    : "hover:bg-[var(--hover-bg)]";
  const barStyle = bgColor
    ? ({ width, backgroundColor: bgColor, "--hover-bg": bgHoverColor } as React.CSSProperties)
    : ({ width, "--hover-bg": bgHoverColor } as React.CSSProperties);
  const barClassName = twMerge(
    "h-5 transition-colors",
    isLast && "rounded-r-xs",
    !bgColor && theme.variants[variant],
    bgHoverColor && hoverClass
  );

  if (!onClick) {
    return (
      <Stack direction={"horizontal"} gap={hideTitle ? undefined : "sm"}>
        <Box style={barStyle} className={barClassName}></Box>
        {!hideTitle && <span>{title}</span>}
      </Stack>
    );
  }
  return (
    <LinkButtonTo variant={"plain"} onClick={onClick}>
      <Stack direction={"horizontal"} gap={hideTitle ? undefined : "sm"}>
        <Box style={barStyle} className={barClassName}></Box>
        {!hideTitle && <span>{title}</span>}
      </Stack>
    </LinkButtonTo>
  );
};
